function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _excluded = ["size", "component", "name", "children", "customIconPath", "className"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React, { Component } from 'react';
import { string, oneOf, element } from 'prop-types';
import classNames from 'classnames'; // import icons from '@ruter-ds/rds-icons/dist/data/rds-icons.json';

import iconSizes from '@ruter-ds/rds-tokens/dist/json/icons.json';
import './Icon.scss';
import ReactSVG from 'react-svg';
var propTypes = {
  /** A predefined set of icon sizes. */
  size: oneOf(['small', 'medium', 'large']),

  /** Use the icon you want to display. (Don't use this prop if you need a custom icon.)
   * @see See [Icons](/#/Icons) for a complete overview of icons. */
  component: element,

  /** The path to your custom svg icon (e.g. 'img/my-custom.svg') */
  customIconPath: string,

  /** Add customs classes to icon wrapper */
  className: string,

  /** @deprecated Please use the component prop.*/
  name: string
};
var defaultProps = {
  size: 'medium'
};
/** Icons help create context and better usability. The Icon component is a helper wrapping svg icons. */

var Icon = /*#__PURE__*/function (_Component) {
  _inherits(Icon, _Component);

  var _super = _createSuper(Icon);

  function Icon() {
    _classCallCheck(this, Icon);

    return _super.apply(this, arguments);
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          size = _this$props.size,
          component = _this$props.component,
          name = _this$props.name,
          children = _this$props.children,
          customIconPath = _this$props.customIconPath,
          className = _this$props.className,
          rest = _objectWithoutProperties(_this$props, _excluded);

      var iconSize;
      var iconSizeClass;

      if (size === 'small') {
        iconSize = iconSizes.ICN_SIZE_S.replace('px', '');
        iconSizeClass = 'rds-icn--small';
      } else if (size === 'large') {
        iconSize = iconSizes.ICN_SIZE_L.replace('px', '');
        iconSizeClass = 'rds-icn--large';
      } else {
        iconSize = iconSizes.ICN_SIZE_M.replace('px', '');
        iconSizeClass = 'rds-icn--medium';
      }

      var componentClassNames = classNames('rds-icn', iconSizeClass, className);

      if (component && /*#__PURE__*/React.isValidElement(component)) {
        return /*#__PURE__*/React.createElement("span", _extends({
          className: componentClassNames
        }, rest), /*#__PURE__*/React.cloneElement(component, {
          width: iconSize,
          height: iconSize
        })); //If a string is used in the name prop. !!Will be deprecated at some point!!
      } else if (name && typeof name === 'string') {
        console.error('Using the name prop is no longer an option. Please use the component prop and pass in an icon as a React Component instead. ' + 'EXAMPLE usage: <Icon component={<TramIcon/>}/>. REMEMBER to import the icon components from @ruter-ds/rds-icons: import {TramIcon} from "@ruter-ds/rds-icons" '); // const filteredIcons = icons.filter(
        //     icon => icon.name.toLowerCase() === name.toLowerCase()
        // );
        // return filteredIcons.map((icon, index) => (
        //     <span className={componentClassNames} key={index}>
        //         <svg
        //             viewBox={icon.viewBox}
        //             width={iconSize}
        //             height={iconSize}
        //             focusable="false"
        //         >
        //             {icon.paths.map((path, index) => (
        //                 <path d={path.d} key={index} />
        //             ))}
        //         </svg>
        //     </span>
        // ));

        return null;
      } else if (customIconPath) {
        return /*#__PURE__*/React.createElement(ReactSVG, {
          src: customIconPath,
          wrapper: "span",
          className: componentClassNames
        });
      } else {
        return /*#__PURE__*/React.createElement("span", {
          className: componentClassNames
        }, children);
      }
    }
  }]);

  return Icon;
}(Component);

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;
export default Icon;